<template>
  <div class="qr-overlay" @click.self="$emit('close')">
    <div class="qr-card">
      <button class="qr-card__close" @click="$emit('close')">✕</button>
      <h3 class="qr-card__title">Your ticket QR code</h3>
      <p class="qr-card__sub">Show this QR code at the entrance.</p>

      <div v-if="used" class="qr-card__used-warning" role="alert">
        <strong>This ticket has already been used.</strong>
        It may be refused at the entrance.
      </div>

      <div class="qr-card__img-wrap">
        <img v-if="qrBase64" :src="`data:image/png;base64,${qrBase64}`" alt="QR code" class="qr-card__img" />
        <div v-else class="qr-card__spinner">Loading…</div>
      </div>

      <p v-if="ticketLabel" class="qr-card__label">{{ ticketLabel }}</p>
      <p v-if="qrCode" class="qr-card__code">{{ qrCode }}</p>

      <a
        v-if="qrBase64"
        :href="`data:image/png;base64,${qrBase64}`"
        :download="downloadName"
        class="qr-card__download-btn"
      >Save QR code</a>

      <button class="qr-card__close-btn" @click="$emit('close')">Close</button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'QrModal',
  props: {
    qrBase64: { type: String, default: null },
    qrCode: { type: String, default: null },
    ticketLabel: { type: String, default: null },
    used: { type: Boolean, default: false },
  },
  computed: {
    downloadName() {
      return `ticket-qr-${this.qrCode || 'code'}.png`
    },
  },
}
</script>

<style scoped lang="scss">
$surface: #ffffff;
$bg: #f8f8fa;
$text: #0a0a0a;
$radius-lg: 36px;
$radius-pill: 44px;

.qr-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0,0,0,0.45);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}

.qr-card {
  background: $surface;
  border-radius: $radius-lg;
  padding: 40px 48px 32px;
  width: 360px;
  max-width: calc(100vw - 32px);
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
  position: relative;

  &__close {
    position: absolute;
    top: 20px;
    right: 24px;
    background: none;
    border: none;
    font-size: 20px;
    cursor: pointer;
    color: $text;
    line-height: 1;
  }

  &__title {
    font-size: 22px;
    font-weight: 800;
    margin: 0;
  }

  &__sub {
    font-size: 14px;
    color: rgba(10,10,10,0.55);
    margin: 0;
    text-align: center;
  }

  &__used-warning {
    width: 100%;
    box-sizing: border-box;
    background: #fff4e5;
    border: 1px solid #f5c27a;
    border-radius: 14px;
    padding: 10px 14px;
    font-size: 13px;
    line-height: 1.4;
    color: #8a4b00;
    text-align: center;

    strong {
      display: block;
      font-weight: 800;
    }
  }

  &__img-wrap {
    margin: 16px 0 4px;
    width: 220px;
    height: 220px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: $bg;
    border-radius: 16px;
  }

  &__img {
    width: 200px;
    height: 200px;
    object-fit: contain;
  }

  &__spinner {
    font-size: 14px;
    color: rgba(10,10,10,0.4);
  }

  &__label {
    font-size: 13px;
    font-weight: 700;
    color: $text;
    margin: 0;
    text-align: center;
    letter-spacing: 0.02em;
  }

  &__code {
    font-size: 12px;
    font-family: monospace;
    color: rgba(10,10,10,0.45);
    margin: 0;
    letter-spacing: 0.08em;
  }

  &__download-btn {
    width: 100%;
    background: rgba(10,10,10,0.06);
    color: $text;
    border: 1px solid rgba(10,10,10,0.12);
    border-radius: $radius-pill;
    padding: 12px 24px;
    font-size: 15px;
    font-weight: 700;
    cursor: pointer;
    text-align: center;
    text-decoration: none;
    display: block;
  }

  &__close-btn {
    width: 100%;
    background: linear-gradient(135deg, #c4b5fd 0%, #f9a8d4 100%);
    color: $text;
    border: none;
    border-radius: $radius-pill;
    padding: 14px 24px;
    font-size: 15px;
    font-weight: 800;
    cursor: pointer;
  }
}
</style>
